// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__msxrs {
  min-height: 51px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.styles_logoText__Pq71a {
  margin-right: auto;
  font-size: 22px;
  font-weight: 900;
  letter-spacing: 1px;
  color: #ffffff;
}

.styles_logoIcon__BHbPE {
  position: relative;
  z-index: 1001;
}
.styles_logoIcon__BHbPE img {
  height: 70px;
}`, "",{"version":3,"sources":["webpack://./src/components/sideMenu/logoBlock/styles.module.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kDAAA;AADF;;AAIA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cChBM;ADeR;;AAIA;EACE,kBAAA;EACA,aAAA;AADF;AAGE;EACE,YAAA;AADJ","sourcesContent":["@import './src/assets/styles/variables/colors';\n\n.wrapper {\n  min-height: 51px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-bottom: 24px;\n  border-bottom: 1px solid $white-4;\n}\n\n.logoText {\n  margin-right: auto;\n  font-size: 22px;\n  font-weight: 900;\n  letter-spacing: 1px;\n  color: $white;\n}\n\n.logoIcon {\n  position: relative;\n  z-index: 1001;\n\n  img {\n    height: 70px;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__msxrs`,
	"logoText": `styles_logoText__Pq71a`,
	"logoIcon": `styles_logoIcon__BHbPE`
};
export default ___CSS_LOADER_EXPORT___;
